var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDImpersonate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2084 48.9999V44.3333C53.2069 42.2653 52.5309 40.2564 51.2865 38.622C50.0422 36.9876 48.2999 35.8203 46.3334 35.3033",
    fill: "url(#paint0_linear_21_142668)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4584 49V44.3333C39.4584 41.858 38.4926 39.484 36.7735 37.7337C35.0544 35.9833 32.7228 35 30.2917 35H11.9584C9.5272 35 7.19563 35.9833 5.47654 37.7337C3.75746 39.484 2.79169 41.858 2.79169 44.3333V49",
    fill: "url(#paint1_linear_21_142668)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 7.30334C39.1385 7.81738 40.8861 8.98498 42.1342 10.6221C43.3822 12.2592 44.0597 14.2726 44.0597 16.345C44.0597 18.4174 43.3822 20.4309 42.1342 22.068C40.8861 23.705 39.1385 24.8726 37.1667 25.3867",
    fill: "url(#paint2_linear_21_142668)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 25.6667C26.1876 25.6667 30.2916 21.488 30.2916 16.3333C30.2916 11.1787 26.1876 7 21.125 7C16.0624 7 11.9583 11.1787 11.9583 16.3333C11.9583 21.488 16.0624 25.6667 21.125 25.6667Z",
    fill: "url(#paint3_linear_21_142668)",
    stroke: "url(#paint4_linear_21_142668)",
    strokeWidth: 2.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_142668",
    x1: 47.1301,
    y1: 35.3033,
    x2: 56.2783,
    y2: 41.4527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_142668",
    x1: 7.04091,
    y1: 35,
    x2: 12.3662,
    y2: 53.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_142668",
    x1: 37.9655,
    y1: 7.30335,
    x2: 48.5293,
    y2: 12.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_142668",
    x1: 14.0829,
    y1: 7,
    x2: 27.0569,
    y2: 24.0643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21_142668",
    x1: 14.0829,
    y1: 7,
    x2: 27.0569,
    y2: 24.0643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDImpersonate);
export default __webpack_public_path__ + "static/media/d_impersonate.0c9eeb39c58e3590b0e06d407883d083.svg";
export { ForwardRef as ReactComponent };